export default __webpack_public_path__ + "static/media/bg_gigabarians.41e381e7.svg";